module.exports = __webpack_public_path__ + "static/media/Beach1.e01babd4.jpg";